// Word Search page entry; on a daily page, swaps in the puzzle for the player's local date when needed.
import { WordSearchGame } from "../word-search/ui"
import { fetchDaily, mountCalendar, pageDate, updateLabel } from "../lib/daily"
import type { WordPuzzle } from "../word-search/core"

async function start(): Promise<void> {
  const root = document.getElementById("board")
  if (!root) return
  const game = root.dataset.dailyGame
  if (game) {
    const { date } = pageDate(root)
    updateLabel(date)
    if (date !== root.dataset.dailyDate) {
      const daily = await fetchDaily<{ puzzle: WordPuzzle }>(game, date)
      if (daily) root.dataset.puzzle = JSON.stringify(daily.puzzle)
    }
    ;(window as unknown as { dtGame?: WordSearchGame }).dtGame = new WordSearchGame(root, { game, date })
    mountCalendar(game, "/word-search")
    return
  }
  ;(window as unknown as { dtGame?: WordSearchGame }).dtGame = new WordSearchGame(root)
}

void start()
